import React, { Fragment } from 'react';
import i18n from 'i18next';
import { Link, useForm } from '@inertiajs/inertia-react';
import '@inertiajs/inertia-react';
import Button from '@/Components/Button';
import ValidationErrors from '@/Components/ValidationErrors';
import { FormInput, PhoneOrEmailInput } from "@/Components/Controls";
import MyGivingIcon from '@/../icons/my-giving.svg';

//This version of the profile slider has been added back in temporarily while we are transitioning to the new profile and login sliders
//with integration to the Individuals service
export default function OriginalProfileSlider({show, props, toggleOriginalProfileSlider}) {
    const showMyGiving = props ? props.auth.user?.my_giving?.enabled : false;
    const showMyChurchProfile = props ? props.auth.user?.my_church_profile?.enabled : false;

    const { data, setData, post, processing, errors } = useForm({
        first_name: props.auth.user.first_name,
        last_name: props.auth.user.last_name,
        email: props.auth.user.email,
        phone: props.auth.user.phone
    });

    const canSelfEdit = props.auth.user.can.canSelfEdit;

    const onChange = (event, value) => {
        setData(event, value);
    };

    const save = (e) => {
        e.preventDefault();

        post(route('manage.profile.store'), {
            onSuccess: () => toggleOriginalProfileSlider(),
        });
    };

    return (
        <Fragment>
            {show && <div className={"fade modal-backdrop slider-backdrop show"} />}
            <div className={show ? "my-profile slider show" : "my-profile slider"}>
                <div className="slider-header">
                    <div className="slider-title">{i18n.t("my-profile-slider.edit-my-profile")}</div>
                    <div className="close-slider">
                        <i onClick={() => toggleOriginalProfileSlider()} className="fa fa-times"></i>
                    </div>
                </div>
                <form onSubmit={save}>
                    <div className="slider-body">
                        {false && <ValidationErrors errors={errors} />}
                        <div className="row">
                            <FormInput error={errors["first_name"]} name="first_name" isFocused={true} autoComplete="first_name" value={data.first_name} onChange={onChange} label={i18n.t("my-profile-slider.first-name")} className="col-12" onKeyUp={e => e.keyCode === 13} dataTestid="my-profile-slider-input-first_name" disabled={!canSelfEdit} />
                        </div>
                        <div className="row">
                            <FormInput error={errors["last_name"]} name="last_name" autoComplete="last_name" value={data.last_name} onChange={onChange} label={i18n.t("my-profile-slider.last-name")} className="col-12" onKeyUp={e => e.keyCode === 13} dataTestid="my-profile-slider-input-last_name" disabled={!canSelfEdit} />
                        </div>
                        <div className="row">
                            <FormInput error={errors["email"]} name="email" autoComplete="email" value={data.email} onChange={onChange} label={i18n.t("my-profile-slider.email")} className="col-12" onKeyUp={e => e.keyCode === 13} dataTestid="my-profile-slider-input-email" disabled={!canSelfEdit} />
                        </div>
                        <div className="row">
                            <PhoneOrEmailInput error={errors["phone"]} name="phone" autoComplete="phone" value={data.phone} onChange={onChange} label={i18n.t("my-profile-slider.phone")} className="col-12" onKeyUp={e => e.keyCode === 13} dataTestid="my-profile-slider-input-phone" disabled={!canSelfEdit} />
                        </div>
                        <div className="row">
                            {showMyChurchProfile &&
                                <div className="col-12">
                                    <div className="my-church-profile-card" onClick={() => window.location.href=props.auth.user.my_church_profile.url}>
                                        <div className="user-avatar-container">
                                            <div className="user-avatar">
                                                <img src={props.auth.user.avatars.md} alt={`${props.auth.user.first_name} ${props.auth.user.last_name} avatar`}/>
                                            </div>
                                        </div>
                                        <div className="module-title">
                                            {i18n.t("my-profile-slider.my-church-profile")}
                                        </div>
                                    </div>
                                </div>
                            }
                            {showMyGiving &&
                                <div className="col-12">
                                    <div className="my-giving-card" onClick={() => window.location.href=props.auth.user.my_giving.url}>
                                        <div className="logo">
                                            <img alt="My Giving" src={MyGivingIcon} />
                                        </div>
                                        <div className="module-title">
                                            {i18n.t("my-profile-slider.my-giving")}
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className="col-12">
                                <Link
                                    href={route('manage.profile.destroy')}
                                    className="btn btn-link"
                                    method="delete"
                                    as="button"
                                    onFinish={() => {
                                        location.reload();
                                    }}
                                >
                                    {i18n.t("my-profile-slider.request-account-deletion")}
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="slider-footer">
                        <Button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => toggleOriginalProfileSlider()} value="Cancel">
                            {i18n.t("my-billing-slider.cancel")}
                        </Button>
                        <Button className="btn btn-sm btn-primary" processing={processing}>
                            {i18n.t("my-profile-slider.save")}
                        </Button>
                    </div>
                </form>
            </div>
        </Fragment>
    );
}
